import { render, staticRenderFns } from "./IntradorLoader.vue?vue&type=template&id=0f6784c4&scoped=true&"
import script from "./IntradorLoader.vue?vue&type=script&lang=ts&"
export * from "./IntradorLoader.vue?vue&type=script&lang=ts&"
import style0 from "./IntradorLoader.vue?vue&type=style&index=0&id=0f6784c4&scoped=true&lang=css&"
import style1 from "./IntradorLoader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6784c4",
  null
  
)

export default component.exports